var map = {
	"./1.png": "4022",
	"./2.png": "653b",
	"./3.png": "189b",
	"./4.png": "41a5",
	"./5.png": "3f4c",
	"./6.png": "5a38",
	"./bgc.png": "d175"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b632";